import { createAction } from '@reduxjs/toolkit'
import { createReducer, createTypes } from 'reduxsauce'
import { types as checkoutTypes } from 'reduxModules/checkout'
import authTypes from 'reduxModules/auth/types'
import fetchApi, { getUrl } from '../utils/fetch'

//
// ACTIONS
// -----------------------------------------------------------------------------

export const types = createTypes(`
  VALIDATE_DISCOUNT_CODE_SUCCESS
  VALIDATE_DISCOUNT_CODE_REQUEST_FAILURE
  DISCOUNT_CODE_LOADING
  DISCOUNT_CODE_SUCCESS
  DISCOUNT_CODE_ERROR
  TOGGLE_DISCOUNT_CODE
  CLEAR_DISCOUNT_CODE
  SAVE_VALIDATED_CODE
  REJECT_DISCOUNT_CODE
`)

//
// REDUCER
// -----------------------------------------------------------------------------

export const INITIAL_STATE = {
  validatedCode: {},
  // SPEC-059: the last refusal, kept raw (the backend's 4xx body, or a
  // client-side reason) so the field can show the server's own words.
  failure: null
}

export const codeStatus = {
  loading: types.DISCOUNT_CODE_LOADING,
  success: types.DISCOUNT_CODE_SUCCESS,
  error: types.DISCOUNT_CODE_ERROR
}

export const validateCodeSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  status: codeStatus.success,
  validatedCode: action.payload,
  failure: null,
  showDiscountCodeForm: false
})

export const setValidatedCode = (state = INITIAL_STATE, action) => ({
  ...state,
  validatedCode: action.payload
})

// On a 400 fetchFailureMiddleware hands reducers the raw response body; other
// statuses arrive as fetchHelper's { value, status }. Both are kept as-is.
export const validateCodeFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  status: codeStatus.error,
  failure: action.payload || true
})

// A code the backend accepted but that produces no discount here (SPEC-059
// FR-3): drop it and explain, rather than leave a silent no-op.
export const rejectCode = (state = INITIAL_STATE, action) => ({
  ...state,
  status: codeStatus.error,
  validatedCode: {},
  failure: action.payload || true
})

export const clearCode = () => ({ ...INITIAL_STATE })

export const toggleDiscountForm = (state = INITIAL_STATE) => {
  const prevState = state.showDiscountCodeForm ? clearCode() : state
  // Removing all keys when closing in order to avoid issues with different forms
  return {
    ...prevState,
    showDiscountCodeForm: !state.showDiscountCodeForm
  }
}

export const HANDLERS = {
  [types.VALIDATE_DISCOUNT_CODE_SUCCESS]: validateCodeSuccess,
  [types.VALIDATE_DISCOUNT_CODE_REQUEST_FAILURE]: validateCodeFailure,
  [types.TOGGLE_DISCOUNT_CODE]: toggleDiscountForm,
  [types.CLEAR_DISCOUNT_CODE]: clearCode,
  [types.SAVE_VALIDATED_CODE]: setValidatedCode,
  [types.REJECT_DISCOUNT_CODE]: rejectCode,
  [checkoutTypes.SETTLE_ORDER_SUCCESS]: clearCode,
  [authTypes.AUTH_LOGOUT_SUCCESS]: clearCode
}

export default createReducer(INITIAL_STATE, HANDLERS)

//
// ACTION CREATORS
// -----------------------------------------------------------------------------

export const validateDiscountCodeSuccess = createAction(
  types.VALIDATE_DISCOUNT_CODE_SUCCESS
)
export const validateDiscountCodeFailure = createAction(
  types.VALIDATE_DISCOUNT_CODE_REQUEST_FAILURE
)
export const validateDiscountCode = (code, plan) => {
  let url = `/coupons/${encodeURI(code)}/`
  if (typeof plan === 'number') url = getUrl(url, { plan })
  return fetchApi(
    url,
    { method: 'GET' },
    validateDiscountCodeSuccess,
    validateDiscountCodeFailure
  )
}

export const toggleDiscountCode = createAction(types.TOGGLE_DISCOUNT_CODE)

export const clearDiscountCode = createAction(types.CLEAR_DISCOUNT_CODE)

export const saveValidatedCode = createAction(types.SAVE_VALIDATED_CODE)

export const rejectDiscountCode = createAction(types.REJECT_DISCOUNT_CODE)
